import call from "../../../shared/service/http";
import ProjectConstants from "@/packages/project/ProjectConstants";

export default {
    namespaced: true,
    state: {
        projects: [],
    },
    mutations: {
        MUTATE: (state, payload) => {
            state[payload.state] = payload.data;
        },
    },
    getters: {
        ProjectGetter: (state) => (setup) => state[setup],
    },
    actions: {
        /**
         *
         * @param commit
         */
        projects({commit}) {
            call('get', ProjectConstants.PROJECTS)
                .then(res=> {
                    if (res.data.success) {
                        commit("MUTATE", {
                            state: "projects",
                            data: res.data.data,
                        });
                    }
                    else{
                        Event.$emit("ApiError", 'Something went wrong');
                    }
                })
                .catch(err=>{
                    Event.$emit("ApiError", err.response.data.message);
                })
        },
        /**
         *
         * @param placeholder
         * @param payload
         */
        project({dispatch}, payload) {
            call('post', ProjectConstants.PROJECTS, payload)
                .then(res=> {
                    if (res.data.success) {
                        Event.$emit("ApiSuccess", res.data.message)
                        dispatch('projects')
                    }
                    else{
                        Event.$emit("ApiError", 'Something went wrong');
                    }
                })
                .catch(err=>{
                    Event.$emit("ApiError", err.response.data.message);
                })
        }
    }
}
